<template>
	<div>
		<MainTempComp
			ref="mainTempRef"
			:searchOption="data.searchOption"
			:handleSearch="handleSearch"
		>
			<template #header>
				<span style="padding-left: 10px"></span>
				<el-button type="primary" @click="handleSearch">查询</el-button>
			</template>
			<template #main>
				<tableComp :tableData="data.tableData"></tableComp>
			</template>
		</MainTempComp>
	</div>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./table.vue";
import { apiOrderList } from "@/api/requestApis.js";
export default {
	name: "orderManage",
	components: {
		tableComp,
	},
	setup() {
		const mainTempRef = ref(null);

		const data = reactive({
			tableData: [],
			searchOption: [
				{
					name: "订单号",
					type: "input",
					key: "orderNo",
					value: "",
				},
				{
					name: "下单时间",
					type: "datePicker",
					key: "time",
					value: "",
					defaultValue: [],
					paramsKey: {
						start_time: "startDate",
						end_time: "endTime",
					},
				},
				{
					name: "停车场名称",
					type: "searchAddress",
					key: "parkingLotId",
					value: "",
					valueType: "id",
				},
                {
                    name: "用户手机号",
                    type: "input",
                    key: "phone",
                    value: "",
                },
			],
		});

		// 设置默认时间
		const setTimeDefaultVal = () => {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			data.searchOption[1].value = [
				dayjs(start).format("YYYY-MM-DD"),
				dayjs(end).format("YYYY-MM-DD"),
			];
		};
		setTimeDefaultVal();

		const handleSearch = async () => {
			const res = await apiOrderList({
				size: mainTempRef.value.pageSize,
				current: mainTempRef.value.currentPage,
				...mainTempRef.value.searchParams,
			});
			if (res) {
				mainTempRef.value.setTotalValue(res.total || 0);
				data.tableData = res.list || [];
			}
		};
		provide("handleSearch", handleSearch);
		onMounted(() => {
			handleSearch();
		});
		return {
			mainTempRef,
			data,
			handleSearch,
		};
	},
};
</script>

<style scoped>
</style>
